import { track as gtmTrack } from './adapters/google_tag_manager.js'
import { track as segmentTrack } from './adapters/segment.js'
import { track as uaTrack } from './adapters/universal_analytics.js'

// Track if product page visitor signals event has been sent this session
let visitorSignalsTracked = false

/**
 * Gets raw visitor signals for analytics.
 * These can be analyzed in SQL to detect AI referrals/agents.
 * @returns {{ url: string, referrer: string | null, user_agent: string }}
 */
export function getVisitorSignals () {
  let referrerHostname = null
  try {
    if (document.referrer) {
      referrerHostname = new URL(document.referrer).hostname
    }
  } catch {
    // Invalid referrer URL, leave as null
  }

  return {
    url: window.location.href,
    referrer: referrerHostname,
    user_agent: navigator.userAgent
  }
}

// Track analytics. Default to sending to both Provenance and client analytics
export function track (eventData, roles = ['provenance', 'client']) {
  if (window.provenance && window.provenance.disableAnalytics) {
    console.debug('Provenance: Analytics tracking call ignored')
    return
  }

  roles.forEach((role) => {
    switch (role) {
      case 'client': gtmTrack(eventData.ga); break
      case 'provenance': uaTrack(eventData.ga); break
    }
  })
  if (eventData.segment) {
    segmentTrack(eventData.segment)
  }
}

/**
 * Tracks product page visitor signals.
 * Only fires once per session.
 */
export function trackProductPageVisitorSignals () {
  if (visitorSignalsTracked) return
  if (window.provenance && window.provenance.disableAnalytics) return
  if (typeof fetch === 'undefined') return

  visitorSignalsTracked = true

  const signals = getVisitorSignals()

  segmentTrack({
    object: 'productPage',
    action: 'viewed',
    ...signals
  })
}

export function listenForImpressions (container, detectedCallback) {
  const observer = createObserver(detectedCallback)

  observer.observe(container)
}

function createObserver (detectedCallback) {
  const options = {
    threshold: 0.5
  }

  return new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!observer) {
          console.log('Observer is undefined or null')
        } else {
          observer.disconnect()
        }
        detectedCallback()
      }
    })
  }, options)
}
